import api from '@/http'

const getters = {
  current: state => state.all.find(i => i.id === state.current)
}

const actions = {
  async load ({ commit, state }) {
    var resp = await api.get(`locations/${state.type}`)
    commit('receiveAll', resp.data)
  }
}

const mutations = {
  setCurrent (state, id) {
    state.current = id
  },

  receiveAll (state, { all, current }) {
    state.all = all
    state.current = current
  }
}

export default function (type) {
  return {
    namespaced: true,
    state: {
      type,
      current: {},
      all: []
    },
    getters,
    actions,
    mutations
  }
}
